import * as React from 'react';
import * as _ from 'underscore';

import { IGlob } from '../../../../_common/application/ts/Glob';
//import { IMarkedItems } from '../AppSettingsFlatCheckList';

export class SqlTestCasesModelExport extends React.Component<
    {
        glob: IGlob;

        onChange?(obj: { dataSources: number[] }): void;
    },
    {
        //value?: number[];
    }
> {
    constructor(props) {
        super(props);

        // this.state = {
        //     value: this.props.value
        // }
    }

    // componentDidMount() {
    //     this.props.glob.AttrQueryStore.addChangeListener(this.handleAttrQueryStoreChange);
    //     //this.props.glob.AttrQueryStore.loadDataSources();
    // }

    // componentWillUnmount() {
    //     this.props.glob.AttrQueryStore.removeChangeListener(this.handleAttrQueryStoreChange);
    // }

    // handleAttrQueryStoreChange = () => {
    //     this.setState(this.state);
    // };

    // handleChange = (markedList: IMarkedItems) => {
    //     let newValue: number[] = [];

    //     _.each(markedList, (value, key) => {
    //         newValue.push(parseInt(key));
    //     });

    //     this.setState({ value: newValue });

    //     if (typeof this.props.onChange === 'function') {
    //         this.props.onChange({ dataSources: newValue });
    //     }
    // };

    render() {
        return (
            <div className="app-settings-export">
                <span>{'Export selections follow the selections of Entity models'}</span>
            </div>
        );
    }
}

// interface IEntityModelImportState {
//     value?: {};
//     valuesHash?: any;
//     values: any[]; //[{key:true}, ..]
//     displayKey: string;
//     loading: boolean;
// }

// export class SqlTestCasesImport extends React.Component<
//     {
//         input: string[];
//         glob: IGlob;

//         onChange?(obj): void;
//     },
//     IEntityModelImportState
// > {
//     constructor(props) {
//         super(props);

//         this.state = _.extend(this.getState(this.props.input), {
//             value: {}
//         });
//     }

//     getState = (input) => {
//         const valuesHash = _.reduce(
//             input,
//             function (hash, obj, i) {
//                 hash[i] = { name: obj, data: {} };
//                 return hash;
//             },
//             {}
//         );

//         const values = _.range(input.length).map(function (i) {
//             return i.toString();
//         });

//         return {
//             valuesHash: valuesHash,
//             values: values, //[{key:true}, ..]
//             displayKey: 'name',
//             loading: false
//         };
//     };

//     getKeyList = (value) => {
//         return _.chain(value)
//             .map((value, key) => {
//                 return this.state.valuesHash[key][this.state.displayKey];
//             })
//             .compact()
//             .value();
//     };

//     passChange = (obj) => {
//         if (typeof this.props.onChange === 'function') {
//             let _keyList = this.getKeyList(obj);

//             this.props.onChange({
//                 keyList: _keyList //VR: the value should contain the key "keyList" for backend method "import()"
//             });
//         }
//     };

//     handleOnValueChange = (value) => {
//         this.passChange(value);
//         this.setState({ value: value });
//     };

//     render() {
//         const tableOptions: ITableOptions = {
//             value: this.state.value,
//             values: this.state.values,
//             valuesHash: this.state.valuesHash,
//             displayKey: this.state.displayKey,

//             onChange: this.handleOnValueChange
//         };

//         return (
//             <div className="app-settings-import">
//                 <TableSelect2cols options={tableOptions} />
//             </div>
//         );

//         //<span>{ 'Import selections follow the selections of Entity models' }</span>
//     }
// }
